import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-navy" data-id="element-344" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-345" data-mp="2bvcvuiy80sm9">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-346" data-mp="1wzwzg7a64kmp">
          Limited-time offer
        </p>
        <h2 className="mt-3 font-display font-bold uppercase text-white text-2xl sm:text-4xl" data-id="element-347" data-mp="21x6x2a7po2lm">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-348" data-mp="1sxthczszuhsg">
          <Countdown tone="dark" data-id="element-349" data-mp="1sy1tuql7fl34" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-350" data-mp="1szwjujbc23e2">
          After that the price goes up by{' '}
          <span className="font-bold text-crimson-soft" data-id="element-351" data-mp="1e6t148m09jlr">$47</span> and stays
          there.
        </p>
      </div>
    </section>;
}